import React, { useState } from "react";
import {
    Table, TableBody, TableCell, TableHead, TableRow, Card, Box, Button,
    TextField, MenuItem, Select, FormControl, InputLabel, Grid, Paper,
    Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, List, ListItem, ListItemText, ListItemAvatar, Avatar, Chip
} from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckIcon from "@material-ui/icons/CheckCircle";
import StarIcon from "@material-ui/icons/Star";
import WarningIcon from '@material-ui/icons/Warning';
import PersonIcon from '@material-ui/icons/Person';
// import DevelopingIcon from "@material-ui/icons/TipsAndUpdates";
import AttentionIcon from "@material-ui/icons/ReportProblem";
import ErrorIcon from '@material-ui/icons/Error';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import SubActivityService from "./Locality/Service/subActivityService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useEffect } from 'react';
import ActivityService from "./Locality/Service/activityService";
import SuperActivityService from "./Locality/Service/superActivityService"
import StudentService from "./Locality/Service/studentService"
const statuses = ["P", "WA", "WI", "M"]; // Presented, Work with Assistance, etc.
const statusLabels = {
    P: "Presented",
    WA: "Works with Assistance",
    WI: "Works Independently",
    M: "Mastered",
};

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dialogPaper: {
        borderRadius: 12,
        minWidth: 380,
        maxWidth: 520,
    },
    dialogTitle: {
        padding: theme.spacing(2, 2, 1.5),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.type === 'light' ? '#fafafa' : '#1e1e1e',
    },
    dialogContent: {
        padding: theme.spacing(2),
    },
    summaryRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
        alignItems: 'center',
    },
    summaryChip: {
        fontWeight: 600,
    },
    statsRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    studentListContainer: {
        maxHeight: 320,
        overflow: 'auto',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 8,
        backgroundColor: theme.palette.type === 'light' ? '#fafafa' : 'rgba(255,255,255,0.05)',
    },
    studentListItem: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    studentAvatar: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        width: 36,
        height: 36,
    },
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(4, 2),
        color: theme.palette.text.secondary,
    },
    dialogActions: {
        padding: theme.spacing(1.5, 2),
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.type === 'light' ? '#fafafa' : '#1e1e1e',
    },
}));

export default function ActivityAnalysis() {
    const classes = useStyles();
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const [allSuperActivities, setAllSuperActivities] = useState([]);

    const [activityList, setActivityList] = useState([]);
    const [studentsList, setstudentsList] = useState([]);
    const [classId, setClassId] = useState("");
    const [sectionId, setSectionId] = useState("");
    const [sectionList, setSectionList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    var [isLoading, setIsLoading] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    var [studentId, setStudentId] = useState("");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogCategory, setDialogCategory] = useState("");
    const [selectedKey, setSelectedKey] = useState("");
    const keyOptions = [
        { label: 'Strong area', value: 'M,WI' },
        { label: 'Developing area', value: 'WA' },
        { label: 'Needs attention', value: 'P' },
    ];
    const [activeTab, setActiveTab] = useState('');
    
    useEffect(() => {
        getAddClassList();



        return () => {
            setStudentList([]);
            setAddSuperActivityList([]);
            setActivityList([]);
        }
    }, []);
    const colorMap = {
        "P": "#5C9882",
        "WI": "#E6B163",
        "WA": "#A75C9C",
        "M": '#147ad482'
    };
    
    const transformActivityData = (data) => {
        const result = {};
        data.forEach(item => {
            if (["M", "WI", "WA", "P", "Future Plane"].includes(item._id)) {
                result[item._id] = {
                    activities: item.activities || [],
                    studentCount: item.studentCount || 0,
                    students: item.students || [],
                };
            }
        });
        return result;
    };

    const getBucketByKey = (key) => {
        const bucket = activityList && typeof activityList === "object" ? activityList[key] : null;
        return bucket || { activities: [], studentCount: 0, students: [] };
    };

    const getUniqueActivities = (activities) => {
        const seen = new Set();
        return (activities || []).filter((a) => {
            const id = a.activityId ? String(a.activityId) : (a.activityName || "");
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
        });
    };

    const mBucket = getBucketByKey("M");
    const wiBucket = getBucketByKey("WI");
    const waBucket = getBucketByKey("WA");
    const pBucket = getBucketByKey("P");

    // For Strong Areas, use only the first JSON block (_id === "M")
    const strongStudents = mBucket.students;
    const developingStudents = waBucket.students;
    const needsAttentionStudents = pBucket.students;

    const strongCount = mBucket.studentCount;
    const developingCount = waBucket.studentCount;
    const needsAttentionCount = pBucket.studentCount;

    const selectedClass = addClassList.find((c) => c._id === classId);
    const selectedClassName = selectedClass ? selectedClass.className : "";

    const selectedSection = sectionList.find((s) => s._id === sectionId);
    const selectedSectionName = selectedSection ? selectedSection.sectionName : "";

    const getDialogStudents = () => {
        if (dialogCategory === "Strong Areas") return strongStudents;
        if (dialogCategory === "Developing Areas") return developingStudents;
        if (dialogCategory === "Needs Attention") return needsAttentionStudents;
        return [];
    };

    const getUniqueStudentsById = (students) => {
        const seen = new Set();
        return (students || []).filter((s) => {
            const id = s.studentId ? String(s.studentId) : "";
            if (!id || seen.has(id)) return false;
            seen.add(id);
            return true;
        });
    };

    const dialogStudentsRaw = getDialogStudents();
    const dialogStudents = getUniqueStudentsById(dialogStudentsRaw);

    const handleCountClick = (categoryLabel) => {
        setDialogCategory(categoryLabel);
        setDialogOpen(true);
    };

    const onSubmit = (data) => {
        setIsLoading(true); 
        const keys = {
            schooleId: userDetails.schooleId,
            isFuturePlanning: false,
            studentId: studentId || undefined,
            classId: classId || undefined,
            sectionId: sectionId || userDetails.sectionId || undefined,
        };

        ActivityService.findActivityAnalysisReportsList(keys)
            .then((result) => {
                setActivityList(transformActivityData(result));

              
               
             

            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setIsLoading(false); // End loading
            });
    };

    const getAddClassList = () => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            let list = res;
            if (userDetails.role === "TEACHER" && userDetails.classId) {
                list = res.filter(item => item._id === userDetails.classId);
            }
            setAddClassList(list);

            if (userDetails.role === "TEACHER" && userDetails.classId) {
                const selectedClassId = userDetails.classId;
                const teacherSectionId = userDetails.sectionId || "";
                setClassId(selectedClassId);
                setSectionId(teacherSectionId);
                getSectionListByClass(selectedClassId);
                getStudentList({ target: { value: selectedClassId } }, teacherSectionId || undefined);
                getSuperActivityList(selectedClassId);
            } else if (list.length > 0) {
                const defaultClassId = list[0]._id;
                setClassId(defaultClassId);
                setSectionId("");
                getSectionListByClass(defaultClassId);
                getSuperActivityList(defaultClassId);
                getStudentList({ target: { value: defaultClassId } });
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getSectionListByClass = (selectedClassId) => {
        if (!selectedClassId) {
            setSectionList([]);
            setSectionId("");
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
        }).then((res) => {
            let list = Array.isArray(res) ? res : [];
            // if (userDetails.role === "TEACHER" && userDetails.sectionId) {
            //     list = list.filter(
            //         (s) => String(s._id) === String(userDetails.sectionId)
            //     );
            // }
            setSectionList(list);
            // if (userDetails.role === "TEACHER" && userDetails.sectionId && list.length > 0) {
            //     setSectionId(userDetails.sectionId);
            // }
        }).catch(() => {
            setSectionList([]);
        });
    };

    const getSuperActivityList = async (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        try {
            const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId, { classId: classId });
            setAllSuperActivities(res); // Save all to filter later

            // Initial filter (if classId already set)
            if (classId) {
                const filtered = res.filter(item => item.classId?._id === classId);
                setAddSuperActivityList(filtered);
                if (filtered.length > 0) {
                    setActiveTab(filtered[0]._id);
                  //  onSubmit(filtered[0]._id);
                }
            }
        } catch (err) {
            console.error(err);
        }
    };
    // const getSuperActivityList = async ( classId) => {
    //         const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //         try {
    //             const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId, { classId: classId });
    //             setAddSuperActivityList(res);

    //             if (res.length > 0) {
    //                 setActiveTab(res[0]._id);
    //                 onSubmit(res[0]._id,  classId);
    //             }
    //         } catch (err) {
    //             console.error(err);
    //         }
    //     };

    const getStudentList = (event, overrideSectionId) => {
        const selectedClassId = event?.target?.value || classId;
        const body = { classId: selectedClassId };
        const effectiveSectionId =
            overrideSectionId !== undefined
                ? overrideSectionId
                : sectionId || userDetails.sectionId || undefined;
        if (effectiveSectionId) {
            body.sectionId = effectiveSectionId;
        }

        StudentService.getAllStudentById(userDetails.schooleId, body)
            .then((res) => {
                const studentDetails = res.map((student) => ({
                    _id: student._id,
                    studentName: `${student.firstName} ${student.lastName}`,
                    status: true,
                }));
                setStudentList(studentDetails);
            })
            .catch((err) => {
                console.error("Error fetching students:", err);
            });
    };

    const handleTabClick = (superActivityId) => {

        setActiveTab(superActivityId);
        onSubmit(superActivityId);
    };
    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        if (studentId == '') {
            alert("Please Select Student");
            return;
        }
        const getstudentId = { "studentId": studentId, };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            alert(err.response.data.message)
        });
    }
    return (

        <Paper style={{ padding: 20 }}>
            <PageTitle title="Activity  Analysis" />
            <Card sx={{ maxWidth: 345 }}>
                <Box style={{ margin: 15, }} >


                    <Grid container spacing={2} columns={12} style={{ margin: 10, }}  >
                        <Grid item xs={12} sm={6} md={3}  >
                            <FormControl className={classes.formControl} style={{ width: 220 }}
                            >
                                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="classId"
                                    label="selectClass"

                                    onChange={e => {
                                        const selectedClassId = e.target.value;
                                        setClassId(selectedClassId);
                                        setSectionId("");
                                        getSectionListByClass(selectedClassId);
                                        getStudentList(e); // fetch students for selected class

                                        // Filter super activities for selected class
                                        const filtered = allSuperActivities.filter(
                                            item => item.classId?._id === selectedClassId
                                        );
                                        setAddSuperActivityList(filtered);
                                        getSuperActivityList(selectedClassId)
                                        if (filtered.length > 0) {
                                            setActiveTab(filtered[0]._id);
                                           // onSubmit(filtered[0]._id);
                                        } else {
                                            setActivityList([]);
                                            setActiveTab("");
                                        }
                                    }}
                                    value={classId}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}

                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl className={classes.formControl} style={{ width: 220 }}>
                                <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                                <Select
                                    labelId="section-select-label"
                                    id="section-select"
                                    value={sectionId}
                                    onChange={(e) => {
                                        const newSectionId = e.target.value;
                                        setSectionId(newSectionId);
                                        if (classId) {
                                            getStudentList({ target: { value: classId } }, newSectionId || undefined);
                                        }
                                    }}
                                    disabled={!classId || sectionList.length === 0}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {sectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>
                                            {sectionName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}  >
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="studentName">Student Name</InputLabel>
                                <Select
                                    labelId="studentName"
                                    id="studentName"
                                    label="Student Name"
                                    name="studentId"
                                    value={studentId}
                                    onChange={e => { setStudentId(e.target.value) }}

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {studentList.map(({ index, _id, studentName }) => (
                                        <MenuItem key={index} value={_id}>{studentName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                       
                        <Grid item xs={12} sm={6} md={2}>
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                type="button"

                                onClick={() => onSubmit(activeTab)} variant="contained"
                            >
                                Search</Button>
                        </Grid>
                    </Grid>



                </Box>
            </Card>
            
   {/* Cards Displaying Activity Count by Category */}
{/* Cards Displaying Activity Names by Category */}
<Grid container spacing={2} style={{ marginTop: 16 }}>
  {/* Strong Areas */}
  <Grid item xs={12} sm={6} md={4}>
    <Card style={{ backgroundColor: "#e8f5e9", padding: 20, height: '100%' }}>
      <h3 style={{ color: "#2e7d32", marginBottom: 10 }}>
        <CheckCircleIcon style={{ verticalAlign: 'middle' }} /> Strong Areas{" "}
        <span
          style={{ marginLeft: 8, cursor: "pointer", fontWeight: "bold" }}
          onClick={() => handleCountClick("Strong Areas")}
        >
          {strongCount}
        </span>
      </h3>
      <ul>
        {getUniqueActivities(["M", "WI"].flatMap(key => getBucketByKey(key).activities)).map((activity, index) => (
          <li key={activity.activityId || index} style={{ fontSize: 14 }}>
            {activity.activityName || "Unnamed Activity"}
          </li>
        ))}
      </ul>
    </Card>
  </Grid>

  {/* Developing Areas */}
  <Grid item xs={12} sm={6} md={4}>
    <Card style={{ backgroundColor: "#fff8e1", padding: 20, height: '100%' }}>
      <h3 style={{ color: "#ef6c00", marginBottom: 10 }}>
        <WarningIcon style={{ verticalAlign: 'middle' }} /> Developing Areas{" "}
        <span
          style={{ marginLeft: 8, cursor: "pointer", fontWeight: "bold" }}
          onClick={() => handleCountClick("Developing Areas")}
        >
          {developingCount}
        </span>
      </h3>
      <ul>
        {getUniqueActivities(waBucket.activities).map((activity, index) => (
          <li key={activity.activityId || `WA-${index}`} style={{ fontSize: 14 }}>
            {activity.activityName || "Unnamed Activity"}
          </li>
        ))}
      </ul>
    </Card>
  </Grid>

  {/* Needs Attention */}
  <Grid item xs={12} sm={12} md={4}>
    <Card style={{ backgroundColor: "#ffebee", padding: 20, height: '100%' }}>
      <h3 style={{ color: "#c62828", marginBottom: 10 }}>
        <ErrorIcon style={{ verticalAlign: 'middle' }} /> Needs Attention{" "}
        <span
          style={{ marginLeft: 8, cursor: "pointer", fontWeight: "bold" }}
          onClick={() => handleCountClick("Needs Attention")}
        >
          {needsAttentionCount}
        </span>
      </h3>
      <ul>
        {getUniqueActivities(pBucket.activities).map((activity, index) => (
          <li key={activity.activityId || `P-${index}`} style={{ fontSize: 14 }}>
            {activity.activityName || "Unnamed Activity"}
          </li>
        ))}
      </ul>
    </Card>
  </Grid>
</Grid>

<Dialog
  open={dialogOpen}
  onClose={() => setDialogOpen(false)}
  PaperProps={{ className: classes.dialogPaper }}
  aria-labelledby="category-dialog-title"
>
  <DialogTitle id="category-dialog-title" className={classes.dialogTitle}>
    <Typography variant="h6" component="span">
      {dialogCategory}
    </Typography>
  </DialogTitle>
  <DialogContent className={classes.dialogContent}>
    {(selectedClassName || selectedSectionName) && (
      <Box className={classes.summaryRow}>
        {selectedClassName && (
          <Chip size="small" label={`Class: ${selectedClassName}`} className={classes.summaryChip} />
        )}
        {selectedSectionName && (
          <Chip size="small" label={`Section: ${selectedSectionName}`} className={classes.summaryChip} />
        )}
        <Chip size="small" color="primary" label={`${dialogStudents.length} student${dialogStudents.length !== 1 ? "s" : ""}`} className={classes.summaryChip} />
      </Box>
    )}
    {!selectedClassName && !selectedSectionName && (
      <Box className={classes.summaryRow}>
        <Chip size="small" color="primary" label={`${dialogStudents.length} student${dialogStudents.length !== 1 ? "s" : ""}`} className={classes.summaryChip} />
      </Box>
    )}
    {dialogCategory === "Strong Areas" && (
      <Box className={classes.statsRow}>
        <Chip size="small" label={`Mastered: ${mBucket.studentCount}`} variant="outlined" />
        <Chip size="small" label={`Works Independently: ${wiBucket.studentCount}`} variant="outlined" />
      </Box>
    )}
    {dialogCategory === "Developing Areas" && (
      <Box className={classes.statsRow}>
        <Chip size="small" label={`Works with Assistance: ${waBucket.studentCount}`} variant="outlined" />
      </Box>
    )}
    {dialogCategory === "Needs Attention" && (
      <Box className={classes.statsRow}>
        <Chip size="small" label={`Presented: ${pBucket.studentCount}`} variant="outlined" />
      </Box>
    )}
    <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: 8 }}>
      Students
    </Typography>
    {dialogStudents.length > 0 ? (
      <div className={classes.studentListContainer}>
        <List dense disablePadding>
          {dialogStudents.map((student, index) => (
            <ListItem key={student.studentId || index} className={classes.studentListItem}>
              <ListItemAvatar>
                <Avatar className={classes.studentAvatar}>
                  <PersonIcon style={{ fontSize: 20 }} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={`${(student.firstName || "").trim()} ${(student.lastName || "").trim()}`.trim() || "Unnamed Student"}
                primaryTypographyProps={{ variant: "body2" }}
              />
            </ListItem>
          ))}
        </List>
      </div>
    ) : (
      <div className={classes.emptyState}>
        <Typography variant="body2">No students in this category.</Typography>
      </div>
    )}
  </DialogContent>
  <DialogActions className={classes.dialogActions}>
    <Button onClick={() => setDialogOpen(false)} color="primary" variant="contained" disableElevation>
      Close
    </Button>
  </DialogActions>
</Dialog>





        </Paper>
        
        
    );
}





































